module.exports = __webpack_public_path__ + "media/src/images/icons/gray-checkmark-02346323ad9d0980ed2ca659ccd41000.svg";